<template>
    <div
        class="add-coupon">
        <div class="add-coupon__title">
            <svg-add-coupon-vivaincontri v-if="isVivaincontri" />
            <div v-else class="coupon-icon coupon-empty"></div>
            <div class="text-lg">{{ trans.title }}</div>
        </div>
        <div class="add-coupon__input">
            <div class="w-full">
                <input
                    maxlength="10"
                    type="text"
                    v-model="coupon_code"
                    class="form-control"
                    :placeholder="trans.placeholder"
                    :class="error ? 'is-invalid' : ''"
                    name="coupon-code-input"
                    @input="coupon_code = coupon_code.replace(/\s/g, '')"
                >
                <div v-if="error" class="invalid-feedback">{{ error }}</div>
            </div>
            <div>
              <ui-button
                  @click="add_coupon"
                  button-type="outline"
                  appearance="secondary"
                  uppercase
                  font-weight="bold"
                  :label="trans.apply"
                  :disabled="!coupon_code"
              />
            </div>
        </div>
        <a
            v-if="showAllCouponsLink"
            @click.prevent="all_coupons_show"
        >{{ trans.view_all }}</a>
        <!-- Modal add coupon -->
        <div ref="couponLinkedModal" class="modal fade" id="couponLinkedModal" tabindex="-1" role="dialog" aria-labelledby="couponLinkedModal">
            <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-transparent border-0">
                        <button type="button" @click="close" class="close font-weight-light outline-none" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body pt-0">
                        <div v-show="couponLoaded" class="flex-column">
                            <div class="text-center d-flex flex-column">
                                <i class="fa fa-check-circle text-4xl text-green-600"></i>
                                <div class="m-1"></div>
                                <div>
                                    <h6 class="mb-0 text-lg">{{ trans.coupon_generated }}</h6>
                                    <span v-show="!canBeUsedImmediately" class="text-base">{{ trans.can_use_it_when_promoting }}</span>
                                </div>
                            </div>
                            <div class="mb-4"></div>
                            <div class="coupon rounded-lg d-flex flex-column h-100 coupon-border py-3 px-4">
                                <div class="flex-grow">
                                    <div class="coupon-header d-flex flex-column xs-flex-row">
                                        <div class="mx-auto xs-mx-0 my-auto">
                                            <div class="coupon-subtitle text-blue-600 text-lg sm-text-xl lg-text-2xl leading-4 pt-1 pt-sm-0">
                                                <h6 class="text-blue-600 font-weight-light text-base sm-text-lg lg-text-xl m-0 d-block mb-0 md-mb-1">{{ coupon.type_title }}</h6>
                                                <h6 class="text-blue-600 font-weight-bold text-lg sm-text-xl lg-text-2xl m-0 d-inline leading-6">
                                                    {{ coupon.title }}
                                                </h6>
                                                <span v-if="isCttProduct" class="font-weight-bold text-lg sm-text-xl lg-text-2xl text-pink-600 text-sm sm-text-base lg-text-lg">{{ coupon.product.value }}</span>
                                            </div>
                                            <div class="coupon-description pt-1 pt-sm-0 text-sm">
                                                <span class="font-weight-light">{{ coupon.description }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-4"></div>
                            <button v-show="!canBeUsedImmediately" type="button" class="btn btn-primary waves-effect rounded-xl w-100" data-dismiss="modal">{{ trans.close }}</button>
                            <use-coupon :url-use-coupon="urlUseCoupon" w100 data-dismiss="modal" v-show="canBeUsedImmediately" :id="coupon.id"></use-coupon>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal all coupon -->
        <div ref="allCouponsModal" class="modal fade" id="allCouponsModal" tabindex="-1" role="dialog" aria-labelledby="imgTopLabel" aria-hidden="true">
            <div class="modal-dialog  modal-dialog-centered  modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h6 class="modal-title text-center text-2xl" id="your-coupons-modalLabel">{{ trans.your_coupons }}</h6>
                        <button type="button" class="close font-weight-light outline-none" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mt-3 mb-4">
                            <h6 class="font-weight-bold">{{ trans.your_coupons_with_nearest_expiration }}</h6>
                        </div>
                        <coupons-list 
                            :url-use-coupon="urlUseCoupon" 
                            :coupons="coupons"
                            :is-vivaincontri="isVivaincontri"
                        ></coupons-list>
                        <div class="text-center">
                          <ui-button :href="urlCouponsPage" button-type="blank" appearance="secondary" uppercase font-weight="bold">
                            {{ trans.view_all }}
                          </ui-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import Translations from "./insert-me-to-translate.vue";

import {getCookie} from "../../../../../../backoffice/static/js/services/cookies";
import UseCoupon from "./use-coupon"
import Coupon from "./coupon"
import CouponsList from "./coupons-list";
import {mapGetters} from "vuex";
import 'whatwg-fetch';

const EMPTY_COUPON = {
    id: '',
    code: null,
    valid_for: null,
    promotion_type: null,
    discount_rate: null,
    valid_from: null,
    valid_to: null,
    type_title: '',
    title: '',
    product: '',
    description: ''
};
const PROMOTION_FREE = 1;
const PROMOTION_EXTRA_CREDITS = 2;
const TYPE_PACKAGE = 'database.models.product.CreditPackageProduct';
const TYPE_PRODUCT = 'database.models.product.CttProduct';
const TYPE_ADDONS = 'addons';

export default {
    name: "AddCoupon",
    props: {
        couponType: {
            required: false,
            default: false,
            validator: function (value) {
                return [
                    TYPE_PACKAGE,
                    TYPE_PRODUCT,
                    TYPE_ADDONS,
                    false
                ].indexOf(value) !== -1
            }
        },
        urlLinkCoupon:{
          required:true,
          type: String
        },
        urlUseCoupon:{
          required:true,
          type: String
        },
        urlCouponsPage:{
          required:true,
          type: String
        },
        coupons: {
            required: false,
            default() {
                return []
            }
        },
        isVivaincontri: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            coupon_code:null,
            coupon:EMPTY_COUPON,
            error: false,
            error_msg:''
        };
    },
    components:{
        UseCoupon,
        Coupon,
        CouponsList,
        UiButton: () => import(/* webpackChunkName: "ui-button" */ "../../ui/ui-button.vue"),
        SvgAddCouponVivaincontri: () => import(/* webpackChunkName: "svg-add-coupon-vivaincontri" */ "../../svg/add-coupon-vivaincontri.vue"),
    },
    computed:{
        ...mapGetters({
            previewCoupon: "coupons/previewCoupon",
            couponsList: "coupons/couponsList",
            hasPreviewCoupon: "coupons/hasPreviewCoupon"
        }),
        couponLoaded(){
            return this.coupon.code != null
        },
        canBeUsedImmediately(){
            return this.isCreditPackage
        },
        isCreditPackage(){ return this.coupon.valid_for==TYPE_PACKAGE },
        isCttProduct(){ return this.coupon.valid_for==TYPE_PRODUCT },
        isAddons() { return this.coupon.valid_for === TYPE_ADDONS},
        isPromotionFree(){return this.coupon.promotion_type==PROMOTION_FREE},
        isPromotionExtraCredits(){return this.coupon.promotion_type==PROMOTION_EXTRA_CREDITS},
        showAllCouponsLink(){
            if(this.couponsList) {
                if(this.couponType){
                  if(this.couponType==TYPE_PACKAGE){
                    return this.couponsList.numCoupons(TYPE_PACKAGE) > 1;
                  }
                  else{
                    return (this.couponsList.numCoupons(TYPE_PRODUCT)+this.couponsList.numCoupons(TYPE_ADDONS)) > 1;
                  }

                }
            }
        },
    },
    created(){
        this.trans = {
            title: gettext("Do you have a Coupon?"),
            placeholder: gettext("Insert coupon code"),
            apply: gettext("Apply"),
            coupon_generated:gettext('Coupon generated successfully'),
            can_use_it_when_promoting: gettext('You can use it when promoting'),
            use_coupon: gettext('Use Coupon'),
            close: gettext('Close'),
            error_title:gettext("An unexpected error has occurred"),
            invalid_coupon:gettext('Invalid coupon'),
            view_all:gettext('View all Coupons'),
            your_coupons:gettext('Coupons'),
            your_coupons_with_nearest_expiration:gettext('Your coupons with the nearest expiration date')
        }
    },
    methods:{
        check_validity(){
            return this.coupon_code && this.coupon_code.length==8;
        },
        close(){
            if(this.isPromotionExtraCredits && this.couponType==TYPE_PACKAGE) {
                this.$store.dispatch("ui/loader/show")
                window.location.reload();
            }
        },
        all_coupons_show(){
            $(this.$refs.allCouponsModal).modal('show');
        },
        all_coupons_hide(){
            $(this.$refs.allCouponsModal).modal('hide');
        },
        add_coupon(){
            if(this.check_validity()) {
                this.coupon=EMPTY_COUPON
                this.error=false
                let post = {
                    'coupon_code': this.coupon_code,
                    'coupon_type': this.couponType,
                };
                this.$store.dispatch("ui/loader/show")
                fetch(this.urlLinkCoupon, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRFToken': getCookie('csrftoken')
                    },
                    body: JSON.stringify(post)
                }).then(response => {
                    console.log(response)
                    if(response.ok) return response.json()
                    return response.json().then(response => {
                        this.$store.dispatch("ui/loader/hide")
                        $(this.$refs.couponLinkedModal).modal('hide');
                        this.error = response.msg || gettext("System error. Please try again later")
                    })
                }).then(data => {
                    console.info(data)
                    if(data){
                        this.coupon = data
                        this.couponsList.addCoupon(data)
                        this.setPreviewCoupon()
                        this.coupon_code = null
                        this.$store.dispatch("ui/loader/hide");
                        $(this.$refs.couponLinkedModal).modal('show');
                    }
                }).catch(error => {
                    $(this.$refs.couponLinkedModal).modal('hide');
                    this.$store.dispatch("ui/loader/hide")
                    this.$store.dispatch("ui/lightbox/show", {
                        title: gettext('Error'),
                        body: gettext("System error. Please try again later"),
                    })
                });
            }else{
                $(this.$refs.couponLinkedModal).modal('hide');
                this.$store.dispatch("ui/loader/hide")
                this.error=gettext('Invalid coupon code');
            }
        },
        setPreviewCoupon(){
          console.log('set preview coupon', this.coupon)
          this.$store.dispatch("coupons/setJustAddedCoupon", this.coupon);
          if(this.isAddons) {
            this.$store.dispatch("coupons/setLastAddonsCoupon", this.coupon);
          }
          else if(this.previewCoupon){
            this.previewCoupon.coupon = this.coupon
          }
        }
    },
    mounted() {
        this.coupon=EMPTY_COUPON
        this.$store.dispatch("coupons/setAddCoupon", this).then()
    }
}
</script>

<style>
.add-coupon {

}
.add-coupon__title {
    color: var(--color-body);
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}
.add-coupon__input {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;

    .ui-button {
        max-height: 38px;
    }
}
.add-coupon__btn-show-all.ui-button {
    justify-content: start;
    padding: 0;
}

.add-coupon img {
    width: 40px;
}

.add-coupon input::placeholder {
    font-weight: 300;
    color: var(--color-placeholder);
}
</style>
